(function() {
  const buttonDropdown = document.querySelector('.dropdown-filters');
  const filtersContainer = document.querySelector('.filters__container');
  const filtersHelp = document.querySelectorAll('.filters__help');
  const filtersHelpModal = document.querySelector('.filters__modal__helps');

  if (buttonDropdown) {
    buttonDropdown.addEventListener('click', () => {
      filtersContainer.classList.toggle('active');
    });
  }

  if (filtersHelp.length > 0) {
    filtersHelp.forEach((e) => {
      e.addEventListener('click', () => {
        filtersHelpModal.classList.toggle('hidden');
      });
    });
  }
})();


